import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setComponent } from './actions/dynamicImport';

import Layout from './components/desktop/Layout';
import MobileLayout from './components/mobile/Layout';
import NotFound from './components/common/NotFound';
import Error503 from './components/common/Error503';
import Loader from './components/common/Loader';

class DynamicImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      component: null
    };
  }

  componentDidMount() {
    const { name = '', load, components = {} } = this.props;
    if (name) {
      if (components[name.trim().toLowerCase()]) {
        this.setState({ component: components[name.trim().toLowerCase()] });
      } else if (window.loadedComponent) {
        this.setState({ component: window.loadedComponent });
      } else {
        load()
          .then(module => {
            this.props.setComponent({ name: name.trim().toLowerCase(), instance: module.default });
            this.setState({ component: module.default });
          })
          .catch(error => {
            this.setState({ component: Error503 });
            console.log(error);
          });
      }
    }
  }

  render() {
    let { component: Component } = this.state;
    const {
      name = '',
      superProps = {},
      requireLayout = true,
      desktop = true,
      componentType = 'page',
      otherParams = {}
    } = this.props;

    /**
     * Condition to identify the type of dynamic component is.
     * if "page" type then it will call method this.renderPageBasedComponent(),
     * else we are rendering it here as the "component" as the (id) with name.
     */
    if (Component == null) {
      return null;
    }
    if (componentType.toLowerCase() === 'page') {
      return this.renderPageBasedComponent();
    } else {
      return (
        <div className="dynamic-component" id={`${name}`}>
          {Component === null ? (
            <Loader name={`dynamic-component-${name}-loader`} />
          ) : (
            <Component {...superProps} {...otherParams} />
          )}
        </div>
      );
    }
  }

  renderPageBasedComponent() {
    let { component: Component } = this.state;
    const {
      name = '',
      superProps = {},
      requireLayout = true,
      desktop = true,
      componentType = 'page',
      customLayout: CustomLayout = '',
      otherParams = {}
    } = this.props;

    /**
     * Rendering dynamic component as the page for the desktop or mobile,
     * based on proper provided configuration :
     *   1. Custom Layout : The callee component need to pass this value of (CustomLayout).
     *   2. No Layout : The callee component need to pass this value of (requireLayout) as false.
     *   3. Preconfigured Layout : If either of above mentioned conditioned fail to meet,
     *      then it load component inside layout based on device.
     */

    if (CustomLayout) {
      return (
        <CustomLayout>
          {Component === null ? (
            <Loader name={`dynamic-component-${name}-loader`} />
          ) : (
            <Component {...superProps} {...otherParams} />
          )}
        </CustomLayout>
      );
    } else if (!requireLayout) {
      return <Component {...superProps} {...otherParams} />;
    } else {
      let ProjectLayout = desktop ? Layout : MobileLayout;
      return (
        <ProjectLayout noHeaderTitle={true} footerSeo={true} isFooter={true}>
          {Component === null ? (
            <Loader name={`dynamic-component-${name}-loader`} />
          ) : (
            <Component {...superProps} {...otherParams} />
          )}
        </ProjectLayout>
      );
    }
  }
}

DynamicImport.propTypes = {
  name: PropTypes.string.isRequired,
  load: PropTypes.func.isRequired,
  componentType: PropTypes.string.isRequired,
  superProps: PropTypes.object,
  requireLayout: PropTypes.bool,
  desktop: PropTypes.bool,
  customLayout: PropTypes.func
};

function mapStateToProps(state) {
  const { dynamicComponent: components = {} } = state;
  return { components };
}

function mapDispatchToProps(dispatch) {
  return {
    setComponent: component => {
      dispatch(setComponent(component));
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(DynamicImport);
